// 环境配置 - 改为 'local'、'test' 或 'prod' 快速切换
const ENVIRONMENT = 'En';

// 区域配置 - 改为 'cn'（国内）或 'global'（国外）快速切换
const REGION = 'global';

// 主聊天 API 地址配置
const CHAT_API_CONFIG = {
  local: 'http://192.168.112.24:8081/ai-agent', // 本地开发环境
  test: 'https://apiai-deven.elehear.cn',          // 测试环境
  En: 'https://apikf-uk.aihear.io/',          // 测试环境
  prod: {
    global: 'https://aiagent-v2.aihear.io',      // 正式环境 - 国外
    cn:     'https://aiagent-v2.aihear.cn',       // 正式环境 - 国内（待填写）
  },
};

export const API_URL = (() => {
  const cfg = CHAT_API_CONFIG[ENVIRONMENT];
  return typeof cfg === 'object' ? cfg[REGION] : cfg;
})();

// 反馈接口 API 配置
export const FEEDBACK_API_CONFIG = {
  local: 'https://api-test.aihear.io',  // 本地开发环境复用 test 地址
  test:  'https://api-test.aihear.io',
  prod: {
    global: 'https://api-prod.aihear.io',        // 正式环境 - 国外
    cn:     'https://api.elehear.cn',         // 正式环境 - 国内
  },
};

export const isProd = ENVIRONMENT === 'prod';

export const getAppBackendUrl = () => {
  const cfg = FEEDBACK_API_CONFIG[ENVIRONMENT];
  return typeof cfg === 'object' ? cfg[REGION] : cfg;
};
